var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { NotifyPropertyChangedBase } from '../../../../utilities/reflection';
import { DataType, SourceType } from '../../../../models/queries/queries.models';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
import { I18N } from 'aurelia-i18n';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { DialogServiceConstants } from '../../../../constants/basics/dialog.constants';
import { Router } from 'aurelia-router';
import { GenesisRouterConstants } from '../../../../configuration/router.constants';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
var ManageDashboards = /** @class */ (function (_super) {
    __extends(ManageDashboards, _super);
    function ManageDashboards(dashboardClientService, i18N, dialogClientService, router, notificationService) {
        var _this = _super.call(this) || this;
        _this.dashboardClientService = dashboardClientService;
        _this.i18N = i18N;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.notificationService = notificationService;
        _this.canAddDashboard = true;
        _this.dashboardColumns = [
            {
                sortOrder: 1,
                columnOrder: 1,
                name: 'name',
                dataType: DataType.Default,
                title: _this.i18N.tr('name-text')
            },
            {
                sortOrder: 3,
                columnOrder: 3,
                name: 'isReadonly',
                dataType: DataType.Boolean,
                title: _this.i18N.tr('dashboard-readonly-text')
            },
            {
                sortOrder: 4,
                columnOrder: 4,
                name: _this.i18N.tr('edit-text'),
                dataType: DataType.Icon,
                title: _this.i18N.tr('edit-text'),
                value: function (x) {
                    _this.dialogClientService.show(DialogServiceConstants.URLs.ManageDashboardMeta, {
                        item: x,
                        vm: _this
                    });
                },
                parameter: 'edit',
            },
            {
                sortOrder: 5,
                columnOrder: 5,
                name: _this.i18N.tr('delete-text'),
                dataType: DataType.Icon,
                title: _this.i18N.tr('delete-text'),
                value: function (x) {
                    _this.itemToDelete = x;
                    _this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModal, _this);
                },
                parameter: 'delete',
            }
        ];
        _this.load();
        return _this;
    }
    ManageDashboards.prototype.load = function () {
        var _this = this;
        this.dashboardClientService.getGlobalDashboards().then(function (result) {
            _this.dashboards = {
                source: result.dashboards,
                sourceType: SourceType.Collection,
                columns: _this.dashboardColumns
            };
        });
    };
    ManageDashboards.prototype.delete = function () {
        var _this = this;
        this.dashboardClientService.deleteDashboard(this.itemToDelete.dashboardId).then(function (x) {
            if (x.isSuccess) {
                _this.notificationService.show(_this.i18N.tr('successfully-deleted-text'), _this.i18N.tr('dashboard-has-been-successfully-deleted-text'), NotificationType.Success);
                _this.load();
            }
            else {
                _this.notificationService.show(_this.i18N.tr('warning') + '!', _this.i18N.tr('dashboard-cannot-be-deleted-in-use-text'), NotificationType.Warning);
            }
            _this.dialogClientService.hide();
        }).catch(function (ex) {
            _this.dialogClientService.hide();
        });
    };
    ManageDashboards.prototype.newDashboard = function () {
        require("./manage-dashboard-dialog");
        //add new dashboard
        this.dialogClientService.show(DialogServiceConstants.URLs.ManageDashboardMeta, {
            item: null,
            vm: this
        });
    };
    ManageDashboards.prototype.editDashboard = function (event) {
        var id = event.detail.item.dashboardId;
        var name = event.detail.item.name;
        var global = event.detail.item.isGlobal;
        var isReadonly = event.detail.item.isReadonly;
        if (id) {
            //open edit dashboard layout            
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManageUserDashboards, {
                dashboardId: id,
                name: name,
                isGlobal: global,
                isReadonly: isReadonly
            });
        }
    };
    ManageDashboards = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DashboardClientService, I18N, DialogClientService,
            Router, NotificationClientService])
    ], ManageDashboards);
    return ManageDashboards;
}(NotifyPropertyChangedBase));
export { ManageDashboards };
